import React, { FC, useState } from "react";

//import BackgroundSection from "components/BackgroundSection/BackgroundSection";
//import BgGlassmorphism from "components/BgGlassmorphism/BgGlassmorphism";
// import SectionHeroArchivePage from "components/SectionHeroArchivePage/SectionHeroArchivePage";
// import SectionSliderNewCategories from "components/SectionSliderNewCategories/SectionSliderNewCategories";
// import SectionSubscribe2 from "components/SectionSubscribe2/SectionSubscribe2";
// import { TaxonomyType } from "data/types";

//import SectionGridFilterCard from "containers/ListingStayPage/SectionGridFilterCard";
import { Helmet } from "react-helmet";
import HomeGridFilterCard from "./HomeGridFilterCard";

import FooterNav from "components_custom/FooterNav/FooterNav";

import AlltaInfo  from '../../assets/logo/allta_intro.png';
import ButtonPrimary from "shared/Button/ButtonPrimary";

export interface ListingExperiencesPageProps {
  className?: string;
}

const RegionCategory: FC<ListingExperiencesPageProps> = ({
  className = "",
}) => {
  return (
	<>
		<div
			className={`nc-ListingExperiencesPage relative overflow-y ${className}`}
			data-nc-id="ListingExperiencesPage"
		>
			{/* <Helmet>
				<title>Allta</title>
			</Helmet> */}
		
			

			<div className="container bg-white h-full !p-0 lg:w-[768px]">
				{/* SECTION HERO */}

				
			
				{/* SECTION */}
				<HomeGridFilterCard className="pb-24 pl-[1rem] pr-[1rem]" />

				{/* SECTION 1 */}
				{/* <div className="relative py-16">
					<BackgroundSection />
					<SectionSliderNewCategories
					heading="Explore top destination ✈"
					subHeading="Explore thousands of destinations around the world"
					categoryCardType="card4"
					itemPerRow={4}
					categories={DEMO_CATS}
					sliderStyle="style2"
					uniqueClassName="ListingExperiencesPage"
					/>
				</div> */}

				{/* SECTION */}
				{/* <SectionSubscribe2 className="py-24 lg:py-28" /> */}
			
				
			</div>
			
		</div>
	</>
  );
};

export default RegionCategory;
